async function fileToBinary(file: File): Promise<string> {
  return new Promise((res, rej) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result as string;
      const base64String = result.replace('data:', '').replace(/^.+,/, '');
      res(base64String);
    };
    reader.onerror = err => rej(err);
    reader.readAsDataURL(file);
  });
}

export { fileToBinary };
